import { render } from "./loginform.vue?vue&type=template&id=312da780&scoped=true"
import script from "./loginform.vue?vue&type=script&lang=js"
export * from "./loginform.vue?vue&type=script&lang=js"

import "./loginform.vue?vue&type=style&index=0&id=312da780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312da780"]])

export default __exports__